"use strict";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { addConnectedWallet, setActiveChainId, updateDelegatedState } from "state/wallets/reducer";
import { useEvent } from "utilities/src/react/hooks";
export function useConnectedWallets() {
  const dispatch = useAppDispatch();
  const connectedWallets = useAppSelector((state) => state.wallets.connectedWallets);
  const addWallet = useCallback(
    (wallet) => {
      dispatch(addConnectedWallet(wallet));
    },
    [dispatch]
  );
  return [connectedWallets, addWallet];
}
export function useUpdateDelegatedState() {
  const dispatch = useAppDispatch();
  return useEvent((input) => {
    dispatch(updateDelegatedState(input));
  });
}
export function useSetActiveChainId() {
  const dispatch = useAppDispatch();
  return useEvent((chainId) => {
    dispatch(setActiveChainId({ chainId }));
  });
}
